<!-- Breadcrumb-->
<div class="row pt-2 pb-2">
	<div class="col-sm-9">
		<h4 class="page-title">Basic Input</h4>
		<ol class="breadcrumb">
			<li class="breadcrumb-item"><a href="javaScript:;">Bulona</a>
			</li>
			<li class="breadcrumb-item"><a href="javaScript:;">Forms</a>
			</li>
			<li class="breadcrumb-item active" aria-current="page">Basic Input</li>
		</ol>
	</div>
	<div class="col-sm-3">
		<div ngbDropdown class="btn-group float-sm-right">
			<button type="button" class="btn btn-outline-danger"><i class="fa fa-cog mr-1"></i> Setting</button>
			<button type="button" class="btn btn-danger" id="dropdownBasic5" ngbDropdownToggle> <span class="caret"></span>
			</button>
			<div ngbDropdownMenu aria-labelledby="dropdownBasic5"> 
        		<a href="javaScript:;" ngbDropdownItem>Action</a>
				<a href="javaScript:;" ngbDropdownItem>Another action</a>
				<a href="javaScript:;" ngbDropdownItem>Something else here</a>
				<div class="dropdown-divider"></div> 
				<a href="javaScript:;" ngbDropdownItem>Separated link</a>
			</div>
		</div>
	</div>
</div>
<!-- End Breadcrumb-->
<div class="card">
	<div class="card-header text-uppercase">Form Inputs</div>
	<div class="card-body">
		<form>
			<div class="row">
				<div class="col-12 col-lg-6 col-xl-6">
					<div class="form-group row">
						<label class="col-sm-2 col-form-label">Text</label>
						<div class="col-sm-10">
							<input type="text" class="form-control" value="Jhon Deo">
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6 col-xl-6">
					<div class="form-group row">
						<label class="col-sm-2 col-form-label">Email</label>
						<div class="col-sm-10">
							<input type="text" class="form-control" value="jhon@xyz.com">
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6 col-xl-6">
					<div class="form-group row">
						<label class="col-sm-2 col-form-label">Phone</label>
						<div class="col-sm-10">
							<input type="tel" class="form-control" value="+120-9999999999">
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6 col-xl-6">
					<div class="form-group row">
						<label class="col-sm-2 col-form-label">Url</label>
						<div class="col-sm-10">
							<input type="url" class="form-control" value="https://getbootstrap.com">
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6 col-xl-6">
					<div class="form-group row">
						<label class="col-sm-2 col-form-label">Date</label>
						<div class="col-sm-10">
							<input type="date" class="form-control" value="01/25/2019">
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6 col-xl-6">
					<div class="form-group row">
						<label class="col-sm-2 col-form-label">Time</label>
						<div class="col-sm-10">
							<input type="time" class="form-control" value="12:45:00">
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6 col-xl-6">
					<div class="form-group row">
						<label class="col-sm-2 col-form-label">Month</label>
						<div class="col-sm-10">
							<input type="month" class="form-control" value="Jan 2019">
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6 col-xl-6">
					<div class="form-group row">
						<label class="col-sm-2 col-form-label">Week</label>
						<div class="col-sm-10">
							<input type="week" class="form-control" value="2011-W33">
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6 col-xl-6">
					<div class="form-group row">
						<label class="col-sm-2 col-form-label">Round</label>
						<div class="col-sm-10">
							<input type="text" class="form-control form-control-rounded" value="round input">
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6 col-xl-6">
					<div class="form-group row">
						<label class="col-sm-2 col-form-label">Square</label>
						<div class="col-sm-10">
							<input type="text" class="form-control form-control-square" value="square input">
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6 col-xl-6">
					<div class="form-group row">
						<label class="col-sm-2 col-form-label">Basic</label>
						<div class="col-sm-10">
							<input type="text" class="form-control">
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6 col-xl-6">
					<div class="form-group row">
						<label class="col-sm-2 col-form-label">Password</label>
						<div class="col-sm-10">
							<input type="password" class="form-control" placeholder="Password Input">
						</div>
					</div>
				</div>
			</div>
			<!--end row-->
		</form>
	</div>
</div>
<div class="row">
	<div class="col-lg-6">
		<div class="card">
			<div class="card-header text-uppercase">Disabled input</div>
			<div class="card-body">
				<input type="text" id="disabled-input" disabled="disabled" class="form-control">
			</div>
		</div>
	</div>
	<div class="col-lg-6">
		<div class="card">
			<div class="card-header text-uppercase">Readonly input</div>
			<div class="card-body">
				<input type="text" readonly="readonly" class="form-control">
			</div>
		</div>
	</div>
</div>
<!--End Row-->
<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header text-uppercase">textarea Input</div>
			<div class="card-body">
				<form>
					<div class="form-group row">
						<label for="basic-textarea" class="col-sm-3 col-form-label">Basic textarea</label>
						<div class="col-sm-9">
							<textarea rows="4" class="form-control" id="basic-textarea"></textarea>
						</div>
					</div>
					<div class="form-group row">
						<label for="unresizable-textarea" class="col-sm-3 col-form-label">Unresizable textarea</label>
						<div class="col-sm-9">
							<textarea rows="4" class="form-control" id="unresizable-textarea" resize="none"></textarea>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
<!--End Row-->
<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header text-uppercase">Select Input</div>
			<div class="card-body">
				<form>
					<div class="form-group row">
						<label for="extra-large-select" class="col-sm-3 col-form-label">Extra Large Select</label>
						<div class="col-sm-9">
							<select class="form-control form-control-xl" id="extra-large-select">
								<option>Option 1</option>
								<option>Option 2</option>
								<option>Option 3</option>
								<option>Option 4</option>
								<option>Option 5</option>
							</select>
						</div>
					</div>
					<div class="form-group row">
						<label for="basic-select" class="col-sm-3 col-form-label">Large Input Select</label>
						<div class="col-sm-9">
							<select class="form-control form-control-lg" id="large-select">
								<option>Option 1</option>
								<option>Option 2</option>
								<option>Option 3</option>
								<option>Option 4</option>
								<option>Option 5</option>
							</select>
						</div>
					</div>
					<div class="form-group row">
						<label for="basic-select" class="col-sm-3 col-form-label">Default Select</label>
						<div class="col-sm-9">
							<select class="form-control" id="default-select">
								<option>Option 1</option>
								<option>Option 2</option>
								<option>Option 3</option>
								<option>Option 4</option>
								<option>Option 5</option>
							</select>
						</div>
					</div>
					<div class="form-group row">
						<label for="basic-select" class="col-sm-3 col-form-label">Small Select</label>
						<div class="col-sm-9">
							<select class="form-control form-control-sm" id="small-select">
								<option>Option 1</option>
								<option>Option 2</option>
								<option>Option 3</option>
								<option>Option 4</option>
								<option>Option 5</option>
							</select>
						</div>
					</div>
					<div class="form-group row">
						<label for="multiple-select" class="col-sm-3 col-form-label">Multiple Select</label>
						<div class="col-sm-9">
							<select multiple="multiple" class="form-control" id="multiple-select">
								<option>Option 1</option>
								<option>Option 2</option>
								<option>Option 3</option>
								<option>Option 4</option>
								<option>Option 5</option>
							</select>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
<!--End Row-->
<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header text-uppercase">Inputs Sizing Options</div>
			<div class="card-body">
				<form>
					<div class="form-group row">
						<label for="Xlarge-input" class="col-sm-3 col-form-label">Extra large input</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-xl" id="Xlarge-input">
						</div>
					</div>
					<div class="form-group row">
						<label for="large-input" class="col-sm-3 col-form-label">Large input</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-lg" id="large-input">
						</div>
					</div>
					<div class="form-group row">
						<label for="default-input" class="col-sm-3 col-form-label">Default input</label>
						<div class="col-sm-9">
							<input type="text" class="form-control" id="default-input">
						</div>
					</div>
					<div class="form-group row">
						<label for="small-input" class="col-sm-3 col-form-label">Small input</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" id="small-input">
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
<!--End Row-->